import { Outlet } from 'react-router';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';

export default function SupportBreadcrumbWrapper() {
  useBreadcrumb('routes/support', 'Support');
  return <Outlet />;
}
